module.exports = __webpack_public_path__ + "static/media/miniinfinitybefore.2e5b42d8.jpg";